import { createSlice } from '@reduxjs/toolkit';

import { GetAtashsooziOmumiBimehNamehByShomarehBimehNameh, printBimehNamehAtashsooziOmumi } from '../Action/action';

import AtashsooziOmumiBimehNamehDetailInitialState from './AtashsooziOmumiBimehNamehDetailInitialState';

export const atashsooziOmumiBimehNamehDetailSlice = createSlice({
  name: 'AtashsooziOmumi/BimehNamehDetail',
  initialState: AtashsooziOmumiBimehNamehDetailInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAtashsooziOmumiBimehNamehByShomarehBimehNameh.pending, (state) => {
        state.loading = true;
        state.data = AtashsooziOmumiBimehNamehDetailInitialState.data;
      })
      .addCase(GetAtashsooziOmumiBimehNamehByShomarehBimehNameh.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload !== undefined) {
          state.data = action.payload;
        }
        return state;
      })
      .addCase(GetAtashsooziOmumiBimehNamehByShomarehBimehNameh.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(printBimehNamehAtashsooziOmumi.pending, (state) => {
        state.loading = true;
      })
      .addCase(printBimehNamehAtashsooziOmumi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printBimehNamehAtashsooziOmumi.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default atashsooziOmumiBimehNamehDetailSlice.reducer;
